module.exports = __webpack_public_path__ + "static/img/wbshare.a255524.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wbshare.png
// module id = WSGF
// module chunks = 6